// User-facing slug:  sec588-i01
// S3/entitlement code: SEC588-I01-WORKBOOK

const SLUG_RE = /^([a-z]{3}\d{3}[a-z]?)-([a-z]\d{2})$/i;
const CODE_RE = /^([A-Za-z]{3}\d{3}[A-Za-z]?)-([A-Za-z]\d{2})-WORKBOOK$/;

/**
 * Helper utility to convert an uppercase course to a lowercase course slug.
 * @param codeWithSuffix
 * @returns lowercase string version of the course slug
 */
export function toSlug(codeWithSuffix: string): string {
  const m = codeWithSuffix.match(CODE_RE);
  if (!m) return codeWithSuffix.toLowerCase(); // fallback
  return `${m[1]}-${m[2]}`.toLowerCase();
}

/**
 * Helper utility to convert a lowercase course slug to an uppercourse course code.
 * @param slug
 * @returns uppercase string version of the course code
 */
export function fromSlugToCode(slug: string): string {
  const m = slug.match(SLUG_RE);
  if (!m) return slug.toUpperCase(); // fallback
  return `${m[1].toUpperCase()}-${m[2].toUpperCase()}-WORKBOOK`;
}

// validator for routes/guards to ensure the slug is valid.
export function isValidSlug(s: string): boolean {
  return SLUG_RE.test(s);
}
